<template>
  <div id="app">
    <router-view @touchmove.prevent />
    <loding v-if="isShow" @touchmove.prevent />
    <div class="PayClass container" @touchmove.prevent v-show="PaySelect !== '0'">
      <Pay />
    </div>
    <div class="toast" v-if="toastShow">
      <div style="text-align: center; line-height: 23px">
        {{ toastText }}
      </div>
    </div>
    <div v-show="false">{{ Version }}</div>
  </div>
</template>


<script>
import loding from "../src/components/loading.vue";
import Pay from "../src/components/Pay.vue";
import {
  Getpaypalinfo,
  refresh,
  GetUserId,
  PostBill,
} from "../src/api/MovieApi";
export default {
  name: "App",
  components: {
    loding,
    Pay,
  },
  data() {
    return {
      BillIndex: 1,
      IsPay: false,
      isShow: false,
      PaySelect: "0",
      intervalId: 0,
      toastShow: false,
      toastText: "",
      subInfo: "",
      user_id: "",
      visible: false,
      Version: "1.1.1.0",
    };
  },
  created() {
    this.refreshTok();
    this.intervalId = setInterval(() => this.refreshTok(), 3 * 60 * 1000);
    this.TestPayInfo();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    toast(str) {
      let v = this;
      v.toastText = str;
      v.toastShow = true;
      setInterval(() => (v.toastShow = false), 3000);
    },
    refreshTok() {
      this.$store.commit("initUser");
      if (
        this.$store.state.userInfo !== null &&
        this.$store.state.userInfo !== undefined
      ) {
        this.GetUserIdInfo();
        refresh({
          refresh_token: this.$store.state.userInfo.refresh_token,
        }).then((res) => {
          if (res.status === 401) this.$store.dispatch("SET_LOGOUT");
          if (res.status === 200) {
            let UserInfo = {
              token: res.data.data.access_token,
              refresh_token: res.data.data.refresh_token,
            };
            this.$store.dispatch("SET_LOGGED", UserInfo);
          }
        });
      }
    },
    ShowLoading() {
      this.isShow = true;
    },
    NoShowLoading() {
      this.isShow = false;
    },
    async TestPayInfo() {
      await Getpaypalinfo().then((res) => {
        if (res.status === 200) {
          this.subInfo = res.data.data;
          this.$bus.$data.subInfo = this.subInfo;
        }
      });
    },

    async GetUserIdInfo() {
      this.$store.commit("initUser");
      if (
        this.$store.state.userInfo !== null &&
        this.$store.state.userInfo !== undefined
      ) {
        if (this.user_id === "") {
          await GetUserId({
            access_token: this.$store.state.userInfo.token,
          }).then((res) => {
            if (res.status === 200) {
              this.user_id = res.data.data.id;
              this.$bus.$data.user_id = this.user_id;
            }
          });
        }
      }
    },
    Paycheckuser(data) {
      console.log(data);
      if (this.BillIndex > 3) return;
      this.BillIndex = this.BillIndex + 1;
      this.$store.commit("initUser");
      PostBill({ access_token: this.$store.state.userInfo.token }, data).then(
        (info) => {
          if (info.status === 200) {
            this.toast("Successfully subscribed");
            setTimeout(() => {
              if (this.$route.name === "pay") {
                window.location.href =
                  window.location.origin +
                  "/details?id=" +
                  this.$bus.$data.movieInfo.id;
              } else {
                window.location.href = window.location.href;
              }
            }, 3000);
          } else {
            this.Paycheckuser(data);
          }
        }
      );
    },
  },
  mounted() {
    this.$bus.$on("Countly", (res) => {
      if (this.user_id === "") return;
      Countly.q.push([
        "add_event",
        {
          key: "MicroFlix_PurchaseClick",
          segmentation: {
            user_id: this.user_id,
            product_id: res,
          },
        },
      ]); 
    });
    this.$bus.$on("SingCountly", (res, data) => {
      if (this.user_id === "") return;
      Countly.q.push([
        "add_event",
        {
          key: "MicroFlix_SingPayClick",
          segmentation: {
            user_id: this.user_id,
            uuid: data,
            price: res,
          },
        },
      ]); 
    });
    this.$bus.$on("CountlyClickEven", (evenKey, key, res, isload = true) => {
      let ip = "0.0.0.0";
      if (window.returnCitySN) {
        ip = window.returnCitySN.cip;
      }
      var data = {
        key: evenKey,
        segmentation: {
          ip: ip,
        },
      };
      if (res !== "") {
        data.segmentation[key] = res;
      }
      if (!isload) {
        Countly.q.push(["add_event", data]);
        return;
      }
      setTimeout(function () {
        Countly.q.push(["add_event", data]);
      }, 3000);
    });
    this.$bus.$on("CountlyEven", (evenKey, res) => {
      let ip = "0.0.0.0";
      if (window.returnCitySN) {
        ip = window.returnCitySN.cip;
      }
      setTimeout(function () {
        Countly.q.push([
          "add_event",
          {
            key: evenKey,
            dur: res,
            segmentation: {
              ip: ip,
            },
          },
        ]);
      });
    });

    this.$bus.$on("TestPayInfo", this.TestPayInfo);
    this.$bus.$on("toast", (res) => {
      this.toast(res);
      return 1;
    }),
      this.$bus.$on("ShowPay", async (res, data) => {
        if (res !== "0") {
          if (this.$store.state.userInfo === null) {
            this.$router.push({
              path: "/login",
            });
            return;
          }
        }
        this.PaySelect = res;
        if (res === "0") {
          document.body.style.overflow = "visible";
          return;
        } else {
          document.body.style.overflow = "hidden";
        }
        let SelectPay = [];
        if (this.user_id === "") await this.GetUserIdInfo();
        if (this.subInfo === "") await this.TestPayInfo();
        if (data === "" || data === undefined) {
          SelectPay = this.subInfo.filter(
            (p) => p.vip_level === this.PaySelect
          );
        } else {
          SelectPay = this.subInfo.filter((p) => p.products === data);
        }
        if (SelectPay.length === 0) return;
        this.$bus.$emit("pay", SelectPay[0]);
      });
    this.$bus.$on("checkuser", async (data) => {
      let info = {};
      info.subscription_id = data.subscriptionID;
      info.order_id = data.orderID;
      info.bill_details = data;
      if (this.user_id === "") await this.GetUserIdInfo();
      info.user_id = this.user_id;
      this.BillIndex = 0;
      this.Paycheckuser(info);
    });
  },
};
</script>
<style>
.card__rate {
  top: 5px !important;
  left: 5px !important;
}
body {
  word-spacing: 0px;
}
:root {
  --Foot-white: #818181;
}
.sun-loading {
  width: 60px;
  height: 60px;
  display: block;
  animation: sunLoading 1s steps(12, end) infinite;
  background: transparent url(../static/Image/loading.gif);
  background-size: 100%;
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
}
.sun_err {
  background: transparent url(../static/Image/wuneirong.png);
  background-size: 100%;
}
.toast {
  position: fixed;
  z-index: 2000;
  left: calc(50% - 120px);
  top: calc(48% - 10px);
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  /* -webkit-transform: translateX(-50%) translateY(-50%); */
  /* transform: translateX(-50%) translateY(-50%); */
  text-align: center;
  border-radius: 5px;
  color: white;
  background: rgba(0, 0, 0, 0.8);
  /* height: 75px; */
  padding: 6px 15px;
  width: 240px;
}
.no_cursor {
  cursor: default !important;
}
.no_select {
  /* moz-user-select: -moz-none; */
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.errdiv {
  color: red;
  font-size: 17px;
  position: absolute;
  top: 10px;
  left: calc(100% - 22px);
}
.payDiv {
  background: #1a191f;
  text-align: center;
  color: white;
}
.href {
  color: #f9ab00;
}
.href:hover {
  color: #f9ab00;
  text-decoration: underline;
}
.payDiv a {
  cursor: pointer;
  color: white;
  font-weight: bold;
}
.section__Title {
  font-size: 20px;
  color: #f6f6f6;
  font-weight: 400;
  line-height: 130%;
  margin-bottom: 20px;
}
.payFoot {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.inputErr {
  border-color: rgba(255, 0, 0, 0.7) !important;
}
.pay_class {
  margin: 20px;
}
.PayClass {
  position: fixed;
  background: #1a191f;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  margin-top: 70px;
  left: 0px;
  right: 0px;
}
.payCanl {
  background: #2c2e2f;
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
}
.PayTitle {
  text-align: center;
  margin-top: 30px;
  font-size: 24px;
  font-weight: bold;
  color: white;
}
.searchBg {
  background: url(../static/Image/section.jpg) center center / cover;
}
.innerbox::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  scrollbar-arrow-color: transparent;
}
.innerbox::-webkit-scrollbar-thumb {
  border-radius: 3px;
  -webkit-box-shadow: inset 0 3 5px rgba(0, 0, 0, 0.2);
  background: #f9ab00;
  scrollbar-arrow-color: transparent;
}
.innerbox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.bg {
  background: url(../static/Image/section.jpg) center center / cover no-repeat;
}
.detailbg {
  background: url(../static/Image/section.jpg) center center / cover no-repeat;
  background-attachment: fixed;
}
@media (min-width: 768px) {
  .ItemShow {
    margin-right: 20px;
    margin-left: 0px;
  }
}
@media (max-width: 767px) {
  .ItemShow {
    margin-right: auto;
    margin-left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue